import { createClient } from '@supabase/supabase-js';

const client = createClient(
    'https://zyodcoodndyttolnauvd.supabase.co',
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp5b2Rjb29kbmR5dHRvbG5hdXZkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjkwMDU3MjMsImV4cCI6MjA0NDU4MTcyM30.e01E8mqHamisxV1dyf7v4n_6suVttFCGl0UKeueZ4JI'
);

const supabase = () => client;

export default supabase;